<div class="modal fade" id="kt_modal_add_update_credit_debit_notes" tabindex="-1" aria-hidden="true">
	<div class="modal-dialog modal-dialog-centered mw-800px">
		<div class="modal-content">
			<div class="modal-header p-3 d-flex justify-content-between bg-secondary">
				<h2 class="fw-bold m-0">{{ isEditMode ? 'Update Credit/Debit Note' : 'Add Credit/Debit Note' }}</h2>
				<div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal">
					<i class="ki-duotone ki-cross fs-1">
						<span class="path1"></span>
						<span class="path2"></span>
					</i>
				</div>
			</div>
			<form [formGroup]="creditDebitNoteForm" (ngSubmit)="onSubmit()" novalidate>
				<div class="modal-body p-5">
					<div class="row">
						<!-- Customer Name (Searchable) -->
						<div class="col-md-6 mb-5">
							<label for="customer_name" class="form-label fs-7 fw-semibold mb-2">Customer Name <span class="required"></span></label>
							<div class="position-relative">
								<input
									type="text"
									id="customer_name"
									class="form-control form-control-sm"
									[class.is-invalid]="creditDebitNoteForm.get('customer_name')?.invalid && creditDebitNoteForm.get('customer_name')?.touched"
									placeholder="Search Customer"
									[(ngModel)]="customerSearchTerm"
									(input)="onCustomerSearchInput($event)"
									(focus)="onCustomerInputFocus()"
									(blur)="onCustomerInputBlur()"
									[ngModelOptions]="{standalone: true}"
									autocomplete="off" />

								<!-- Loading Spinner -->
								<div *ngIf="isCustomerSearching" class="position-absolute top-50 end-0 translate-middle-y me-3">
									<div class="spinner-border spinner-border-sm text-primary" role="status">
										<span class="visually-hidden">Loading...</span>
									</div>
								</div>

								<!-- Clear Button -->
								<div *ngIf="selectedCustomer && !isCustomerSearching" class="position-absolute top-50 end-0 translate-middle-y me-3">
									<button type="button" class="btn btn-sm btn-icon btn-active-color-primary" (click)="clearCustomerSearch()">
										<i class="ki-duotone ki-cross fs-2">
											<span class="path1"></span>
											<span class="path2"></span>
										</i>
									</button>
								</div>

								<!-- Dropdown Results -->
								<div *ngIf="showCustomerDropdown" class="dropdown-menu show position-absolute w-100 mt-1 shadow-sm border" style="z-index: 1050; max-height: 300px; overflow-y: auto;">
									<div *ngIf="customerSearchResults.length === 0 && !isCustomerSearching" class="dropdown-item-text text-muted text-center py-3">
										No customers found
									</div>
									<a
										*ngFor="let customer of customerSearchResults"
										href="javascript:void(0)"
										class="dropdown-item d-flex align-items-center py-2"
										(click)="selectCustomer(customer)">
										<div class="d-flex flex-column">
											<span class="fw-bold text-gray-800">{{ getCustomerDisplayName(customer) }}</span>
											<small class="text-muted" *ngIf="customer.email">{{ customer.email }}</small>
											<small class="text-muted" *ngIf="customer.city || customer.country">
												{{ customer.city }}{{ customer.city && customer.country ? ', ' : '' }}{{ customer.country }}
											</small>
										</div>
									</a>
								</div>

								<!-- Validation Error Message -->
								<div *ngIf="creditDebitNoteForm.get('customer_name')?.invalid && creditDebitNoteForm.get('customer_name')?.touched" class="invalid-feedback d-block">
									<div *ngIf="creditDebitNoteForm.get('customer_name')?.errors?.['required']">Customer Name is required</div>
								</div>
							</div>
						</div>

						<!-- Invoice Number -->
						<div class="col-md-6 mb-5">
							<label for="invoice_no" class="form-label fs-7 fw-semibold mb-2">Invoice # <span class="required"></span></label>
							<input type="text" formControlName="invoice_no" id="invoice_no" class="form-control form-control-sm"
								[class.is-invalid]="creditDebitNoteForm.get('invoice_no')?.invalid && creditDebitNoteForm.get('invoice_no')?.touched" />
							<div class="invalid-feedback" *ngIf="creditDebitNoteForm.get('invoice_no')?.invalid && creditDebitNoteForm.get('invoice_no')?.touched">
								<div *ngIf="creditDebitNoteForm.get('invoice_no')?.errors?.['required']">Invoice Number is required</div>
							</div>
						</div>
					</div>

					<div class="row">
						<!-- Date -->
						<div class="col-md-6 mb-5">
							<label for="date" class="form-label fs-7 fw-semibold mb-2">Date <span class="required"></span></label>
							<input type="date" formControlName="date" id="date" class="form-control form-control-sm"
								[class.is-invalid]="creditDebitNoteForm.get('date')?.invalid && creditDebitNoteForm.get('date')?.touched" />
							<div class="invalid-feedback" *ngIf="creditDebitNoteForm.get('date')?.invalid && creditDebitNoteForm.get('date')?.touched">
								<div *ngIf="creditDebitNoteForm.get('date')?.errors?.['required']">Date is required</div>
							</div>
						</div>

						<!-- Type -->
						<div class="col-md-6 mb-5">
							<label for="type" class="form-label fs-7 fw-semibold mb-2">Type <span class="required"></span></label>
							<select formControlName="type" id="type" class="form-select form-select-sm"
								[class.is-invalid]="creditDebitNoteForm.get('type')?.invalid && creditDebitNoteForm.get('type')?.touched">
								<option value="" disabled>Select Type</option>
								<option value="debit">Debit</option>
								<option value="credit">Credit</option>
							</select>
							<div class="invalid-feedback" *ngIf="creditDebitNoteForm.get('type')?.invalid && creditDebitNoteForm.get('type')?.touched">
								<div *ngIf="creditDebitNoteForm.get('type')?.errors?.['required']">Type is required</div>
							</div>
						</div>
					</div>

					<div class="row">
						<!-- Amount -->
						<div class="col-md-6 mb-5">
							<label for="amount" class="form-label fs-7 fw-semibold mb-2">Amount <span class="required"></span></label>
							<input type="number" formControlName="amount" id="amount" class="form-control form-control-sm"
								[class.is-invalid]="creditDebitNoteForm.get('amount')?.invalid && creditDebitNoteForm.get('amount')?.touched" />
							<div class="invalid-feedback" *ngIf="creditDebitNoteForm.get('amount')?.invalid && creditDebitNoteForm.get('amount')?.touched">
								<div *ngIf="creditDebitNoteForm.get('amount')?.errors?.['required']">Amount is required</div>
								<div *ngIf="creditDebitNoteForm.get('amount')?.errors?.['min']">Amount must be greater than or equal to 0</div>
							</div>
						</div>

						<!-- Brief -->
						<div class="col-md-6 mb-5">
							<label for="brief" class="form-label fs-7 fw-semibold mb-2">Brief (0/250) <span class="required"></span></label>
							<textarea formControlName="brief" id="brief" class="form-control form-control-sm" rows="3"
								[class.is-invalid]="creditDebitNoteForm.get('brief')?.invalid && creditDebitNoteForm.get('brief')?.touched"></textarea>
							<div class="invalid-feedback" *ngIf="creditDebitNoteForm.get('brief')?.invalid && creditDebitNoteForm.get('brief')?.touched">
								<div *ngIf="creditDebitNoteForm.get('brief')?.errors?.['required']">Brief is required</div>
								<div *ngIf="creditDebitNoteForm.get('brief')?.errors?.['maxlength']">Brief cannot exceed 250 characters</div>
							</div>
						</div>
					</div>
				</div>

				<div class="modal-footer p-3">
					<button type="button" class="btn btn-sm btn-light me-3" data-bs-dismiss="modal">Cancel</button>
					<button type="submit" class="btn btn-sm btn-primary" [disabled]="isLoading">
						<span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
						{{ isEditMode ? 'Update' : 'Add' }} Credit/Debit Note
					</button>
				</div>
			</form>
		</div>
	</div>
</div>
